var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import LoginButtonList from "../Account/LoginButtonList.vue";
import ProfilePicture from "../Components/ProfilePicture.vue";
import CartAnchor from "../Cart/Anchor.vue";
import { build } from "../Models/SiteMap.ts";
import Sticky from "../Directives/sticky.ts";
var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PageHeader.prototype, "siteMap", {
        get: function () { return build(this.pages, function (p) { return p.showInHeader === true; }, this.homeTitle, this.homeUrl, this.logoUrl); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "homeUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "homeTitle", void 0);
    __decorate([
        Prop({ type: String })
    ], PageHeader.prototype, "logoUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "externalLoginUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "registerUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "loginUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "resetPasswordUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "profileUrl", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageHeader.prototype, "logoutUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], PageHeader.prototype, "showLogin", void 0);
    __decorate([
        Prop({ type: String })
    ], PageHeader.prototype, "userName", void 0);
    __decorate([
        Prop({ type: String })
    ], PageHeader.prototype, "userAvatarUrl", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], PageHeader.prototype, "pages", void 0);
    PageHeader = __decorate([
        Component({
            name: "PageHeader",
            components: {
                LoginButtonList: LoginButtonList,
                ProfilePicture: ProfilePicture,
                CartAnchor: CartAnchor
            },
            directives: {
                Sticky: Sticky
            }
        })
    ], PageHeader);
    return PageHeader;
}(Vue));
export default PageHeader;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App/PageHeader.vue
// module id = 665
// module chunks = 24